import React from 'react';
import { useTranslation } from 'react-i18next';
import { CollectionProperty, CollectionPropertyOption } from '@saga/shared';

import TableMultipleFilterSelect, { ItemsFilterMode } from './TableMultipleFilterSelect';
import { Tag, Check, Square, CheckSquare } from 'react-feather';

export default function PropertyFilterSelect({
    property,
    selectedIds,
    onUpdateSelectedIds,
}: {
    property: CollectionProperty;
    selectedIds: ItemsFilterMode;
    onUpdateSelectedIds(ids: ItemsFilterMode): void;
}) {
    const { t } = useTranslation();

    const availableItems = React.useMemo(() => {
        if (property.type === 'checkbox') {
            return [
                {
                    id: 'checked',
                    title: t('collections.properties.checked'),
                    icon: <CheckSquare size={14} />,
                },
                {
                    id: 'unchecked',
                    title: t('collections.properties.unchecked'),
                    icon: <Square size={14} />,
                },
            ];
        }

        return (property.options || []).map((option: CollectionPropertyOption) => ({
            id: option.id,
            title: option.name,
            icon: <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: option.color }} />,
        }));
    }, [property.type, property.options, t]);

    const icon = property.type === 'checkbox' ? <Check size={14} /> : <Tag size={14} />;

    return (
        <TableMultipleFilterSelect
            selectedIds={selectedIds}
            onUpdateSelectedIds={onUpdateSelectedIds}
            availableItems={availableItems}
            selectTexts={{
                default: property.title,
                all: t('collections.properties.all_options'),
                none: t('collections.properties.no_options'),
                n_items: t('collections.properties.n_options', { count: selectedIds.length }),
                search_item_placeholder: t('collections.properties.search_option_placeholder'),
            }}
            Icon={icon}
        />
    );
}
